import React, { useState, createContext, useContext } from "react";

const SchedulingContext = createContext();

const SchedulingProvider = ({ children }) => {
  const [schedulingData, setSchedulingData] = useState({
    dates: null,
    loading: true,
    error: null,
  });

  return (
    <SchedulingContext.Provider value={[schedulingData, setSchedulingData]}>
      {children}
    </SchedulingContext.Provider>
  );
};

export const useScheduling = () => useContext(SchedulingContext);

export { SchedulingProvider };
